import { render, staticRenderFns } from "./QLOpzioniSFQ.vue?vue&type=template&id=6b442a3a&scoped=true&"
import script from "./QLOpzioniSFQ.vue?vue&type=script&lang=js&"
export * from "./QLOpzioniSFQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b442a3a",
  null
  
)

export default component.exports